import { isProd } from '@/utils/environment'

// Domaine du raccourcisseur (cf. engine config short_links.base_url) : mws.li en prod, s.mws.li ailleurs
export function shortLinkBaseUrl() {
  return process.env.VUE_APP_SHORTENER_BASE_URL || (isProd() ? 'https://mws.li' : 'https://s.mws.li')
}

/**
 * URL de la publication d'un lien sur le réseau (top_links[].publication renvoyé par l'engine), mêmes règles que
 * showOriginalPost du drawer et openOnNetwork de l'overview, sans appel API : null si non constructible
 * (Instagram, TikTok, Telegram, Threads, LinkedIn / Google sans post_number_bis) → ouverture dans Mashup.
 */
export function publicationNetworkUrl(pub) {
  if (!pub) return null
  const id = pub.post_number
  const bis = pub.post_number_bis
  switch (pub.network) {
    case 'facebook': return id ? `https://www.facebook.com/${id}` : null
    case 'twitter': return id && pub.page_name ? `https://www.twitter.com/${pub.page_name}/status/${id}` : null
    case 'linkedin': return bis ? `https://www.linkedin.com/feed/update/${bis}` : null
    case 'pinterest': return id ? `https://www.pinterest.fr/pin/${id}` : null
    case 'google': return /^https?:\/\//.test(bis || '') ? bis : null
    case 'youtube': return id ? `https://www.youtube.com/shorts/${id}` : null
    case 'bluesky': return id && pub.page_name ? `https://bsky.app/profile/${pub.page_name}/post/${String(id).split('/').pop()}` : null
    default: return null
  }
}

// Les documents ES des liens ne portent que le code : l'URL courte est reconstruite ici
export function shortLinkUrl(link) {
  if (!link) return ''
  return link.short_url || `${shortLinkBaseUrl()}/${link.code}`
}
